<!-- echarts 饼图组件封装 -->
<template>
  <div class="myCharts" ref="myCharts"></div>
</template>

<script lang="js">
import * as echarts from "echarts/core"; // 引入 echarts 核心模块
import { PieChart } from "echarts/charts"; // 引入饼状图
import { TooltipComponent } from "echarts/components"; // 引入提示框组件
import { CanvasRenderer } from "echarts/renderers"; // 引入 Canvas 渲染器
echarts.use([TooltipComponent, PieChart, CanvasRenderer]); // 注册必须的组件
export default {
  name: 'EchartsPie',
  props: { options: Object },
  mounted() {
    this.drawPie();
  },
  watch: {
    options: {
      handler(newOpts, oldOpts) {
        this.drawPie(); // 重新绘制报表
      },
      deep: true,
    },
  },
  methods: {
    drawPie() {
      let myCharts = echarts.init(this.$refs.myCharts);
      let option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: this.options.toolTitle,
            type: "pie",
            radius: "80%",
            data: this.options.data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      myCharts.setOption(option)
    }
  },
}
</script>